import Loadable from 'react-loadable'
import Loading from '../views/utils/loading'
import DefaultLayout from '../containers/defaultLayout'

const ReceivableDailyList = Loadable({
  loader: () => import('../views/receivable/receivableDaily'),
  loading: Loading
})

const TransactionDetail = Loadable({
  loader: () => import('../views/transaction/transactionDetail'),
  loading: Loading
})

const TransactionToday = Loadable({
  loader: () => import('../views/transaction/transactionToday'),
  loading: Loading
})

const TransactionToTransaction = Loadable({
  loader: () => import('../views/transaction/transactionToTransaction'),
  loading: Loading
})

const TransactionDaily = Loadable({
  loader: () => import('../views/transaction/transactionDaily'),
  loading: Loading
})

const Mydata = Loadable({
  loader: () => import('../views/mydata/'),
  loading: Loading
})
const Documents = Loadable({
  loader: () => import('../views/documents/'),
  loading: Loading
})
const Products = Loadable({
  loader: () => import('../views/products/'),
  loading: Loading
})

const FindStore = Loadable({
  loader: () => import('../views/findstore'),
  loading: Loading
})

const KeyManagement = Loadable({
  loader: () => import('../views/pix/keyManagement'),
  loading: Loading
})

const CreateKeyForm = Loadable({
  loader: () => import('../views/pix/createKeyForm'),
  loading: Loading
})

// const DeliveryData = Loadable({
//   loader: () => import('../views/delivery'),
//   loading: Loading
// })

const CommonQuestions = Loadable({
  loader: () => import('../views/commonQuestions'),
  loading: Loading
})
const FinancialConciliation = Loadable({
  loader: () => import('../views/conciliation/'),
  loading: Loading
})

const CampaignManager = Loadable({
  loader: () => import('../views/CampaignManager/'),
  loading: Loading
})

const CampaignCreate = Loadable({
  loader: () => import('../views/campaignCreate/'),
  loading: Loading
})

const CampaignResume = Loadable({
  loader: () => import('../views/campaignResume/'),
  loading: Loading
})
const CampaignDetail = Loadable({
  loader: () => import('../views/campaignDetail/'),
  loading: Loading
})

const CampaignManagerFaq = Loadable({
  loader: () => import('../components/CampaignManagerFaq/CampaignManagerFaq'),
  loading: Loading
})

const DiscountsCreate = Loadable({
  loader: () => import('../views/discountsCreate'),
  loading: Loading
})
const DiscountsResume = Loadable({
  loader: () => import('../views/discountsResume/'),
  loading: Loading
})
const CampaignListPage = Loadable({
  loader: () => import('../views/CampaignStepList'),
  loading: Loading
})
const CampaignResult = Loadable({
  loader: () => import('../views/CampaignResult'),
  loading: Loading
})
const DiscountResult = Loadable({
  loader: () => import('../views/DiscountResult'),
  loading: Loading
})

const OfferSaibaMais = Loadable({
  loader: () => import('../views/offerManager/CreateOfferIntro/'),
  loading: Loading
})
const PromoteOfferIntro = Loadable({
  loader: () => import('../views/offerManager/PromoteOfferIntro/'),
  loading: Loading
})
const OfferManager = Loadable({
  loader: () => import('../views/offerManager/'),
  loading: Loading
})
const DescubraSuaOferta = Loadable({
  loader: () => import('../views/descubraSuaOferta/'),
  loading: Loading
})
const CampaignOffer = Loadable({
  loader: () => import('../views/discountOffer/'),
  loading: Loading
})
const routes = [
  {
    path: '/',
    exact: true,
    name: 'Home',
    component: DefaultLayout
  },
  // {
  //   path: '/delivery',
  //   exact: true,
  //   name: 'Delivery',
  //   component: DeliveryData
  // },
  {
    path: '/conta',
    exact: true,
    name: 'Conta',
    component: ReceivableDailyList
  },
  {
    path: '/conta/detalhes/:uuid',
    exact: true,
    name: 'Detalhes da Venda',
    component: TransactionDetail
  },
  {
    path: '/vendas-hoje',
    exact: true,
    name: 'Vendas de hoje',
    component: TransactionToday
  },
  {
    path: '/vendas-hoje/venda-a-venda/:uuid',
    exact: true,
    name: 'Venda ',
    component: TransactionDetail
  },
  {
    path: '/vendas-hoje/detalhes/:uuid',
    exact: true,
    name: 'Detalhes da Venda',
    component: TransactionDetail
  },
  {
    path: '/vendas-fechadas',
    exact: true,
    name: 'Vendas Fechadas',
    component: TransactionDaily
  },
  {
    path: '/conciliacao',
    exact: true,
    name: 'Conciliação',
    component: FinancialConciliation
  },
  {
    path: '/oferta-e-sua/selecionar-tipo-de-oferta',
    exact: true,
    name: 'Selecionar tipo de oferta',
    component: CampaignManager
  },
  {
    path: '/oferta-e-sua/selecionar-tipo-de-oferta/criar-campanha',
    exact: true,
    name: 'Criação de Oferta',
    component: CampaignCreate
  },
  {
    path: '/oferta-e-sua/selecionar-tipo-de-oferta/criar-campanha/resumo-campanha',
    exact: true,
    name: 'Resumo da solicitação da Oferta',
    component: CampaignResume
  },
  {
    path: '/oferta-e-sua/selecionar-tipo-de-oferta/detalhe-campanha',
    exact: true,
    name: 'Detalhe da campanha',
    component: CampaignDetail
  },
  {
    path: '/oferta-e-sua/selecionar-tipo-de-oferta/faq-ajuda',
    exact: true,
    name: 'FAQ e Ajuda',
    component: CampaignManagerFaq
  },
  {
    path: '/oferta-e-sua/selecionar-tipo-de-oferta/criar-desconto',
    exact: true,
    name: 'Criação da oferta de desconto',
    component: DiscountsCreate
  },
  {
    path: '/vendas-fechadas/venda-a-venda',
    exact: true,
    name: 'Venda a venda',
    component: TransactionToTransaction
  },
  {
    path: '/vendas-fechadas/venda-a-venda/detalhes/:uuid',
    exact: true,
    name: 'Detalhes da Venda',
    component: TransactionDetail
  },
  {
    path: '/vendas-fechadas/detalhes/:uuid',
    exact: true,
    name: 'Detalhes da Venda',
    component: TransactionDetail
  },
  {
    path: '/meus-dados',
    exact: true,
    name: 'Meus dados',
    component: Mydata
  },
  {
    path: '/documentos',
    exact: true,
    name: 'Documentos',
    component: Documents
  },
  {
    path: '/produtos',
    exact: true,
    name: 'Produtos',
    component: Products
  },
  {
    path: '/antecipacao',
    exact: true,
    name: 'Antecipação',
    component: Products
  },
  {
    path: '/busca-parceiro',
    exact: true,
    name: 'Parceiros',
    component: FindStore
  },
  {
    path: '/pix/gerenciamento-chaves',
    exact: true,
    name: 'Gerenciamento de chaves',
    component: KeyManagement
  },
  {
    path: '/pix/nova-chave',
    exact: true,
    name: 'Gerenciamento de chaves',
    component: CreateKeyForm
  },
  {
    path: '/perguntas-frequentes',
    exact: true,
    name: 'Perguntas Frequentes',
    component: CommonQuestions
  },
  {
    path: '/oferta-e-sua/selecionar-tipo-de-oferta/criar-desconto/resumo-oferta',
    exact: true,
    name: 'Resumo da oferta de desconto',
    component: DiscountsResume
  },
  {
    path: '/oferta-e-sua/selecionar-tipo-de-oferta/lista-oferta',
    exact: true,
    name: 'Lista de Ofertas',
    component: CampaignListPage
  },
  {
    path: '/oferta-e-sua/selecionar-tipo-de-oferta/resultado-campanha',
    exact: true,
    name: 'Resultado da Campanha',
    component: CampaignResult
  },
  {
    path: '/oferta-e-sua/selecionar-tipo-de-oferta/resultado-desconto',
    exact: true,
    name: 'Resultado do Desconto',
    component: DiscountResult
  },
  {
    path: '/oferta-e-sua',
    exact: true,
    name: 'A oferta é sua',
    component: OfferManager
  },
  {
    path: '/descubra-sua-oferta',
    exact: true,
    name: 'Descubra A Oferta é Sua',
    component: DescubraSuaOferta
  },
  {
    path: '/oferta-e-sua/crie-suas-ofertas',
    exact: true,
    name: 'Crie suas ofertas',
    component: OfferSaibaMais
  },

  {
    path: '/oferta-e-sua/divulgue-suas-ofertas',
    exact: true,
    name: 'Divulgue suas ofertas',
    component: PromoteOfferIntro
  },
  {
    path: '/oferta-e-sua/selecionar-tipo-de-oferta/lista-oferta/detalhe-desconto',
    exact: true,
    name: 'Detalhe da oferta',
    component: CampaignOffer
  },
]

export default routes
